const sorayaRoot = document.querySelector('[data-soraya-home]');

if (sorayaRoot) {
  sorayaRoot.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const targetId = link.getAttribute('href');
      if (!targetId || targetId === '#') return;
      const target = document.querySelector(targetId);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  sorayaRoot.querySelectorAll('.faq-item').forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      sorayaRoot.querySelectorAll('.faq-item[open]').forEach((other) => {
        if (other !== item) other.removeAttribute('open');
      });
    });
  });

  sorayaRoot.querySelectorAll('[data-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-track]');
    const slides = track ? Array.from(track.children) : [];
    const dotsWrap = slider.querySelector('[data-dots]');
    const prevBtn = slider.querySelector('[data-prev]');
    const nextBtn = slider.querySelector('[data-next]');
    if (!track || slides.length < 2) {
      prevBtn?.remove();
      nextBtn?.remove();
      dotsWrap?.remove();
      return;
    }

    let index = 0;
    const dots = slides.map((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
      dot.addEventListener('click', () => go(i));
      dotsWrap?.appendChild(dot);
      return dot;
    });

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach((d, di) => d.classList.toggle('active', di === index));
    }

    prevBtn?.addEventListener('click', () => go(index - 1));
    nextBtn?.addEventListener('click', () => go(index + 1));

    // swipe. only claims the gesture once it is clearly horizontal,
    // so vertical page scrolling over the slider still works
    const SWIPE_THRESHOLD = 40;
    let startX = 0;
    let startY = 0;
    let deltaX = 0;
    let horizontal = null;

    slider.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      deltaX = 0;
      horizontal = null;
    }, { passive: true });

    slider.addEventListener('touchmove', (event) => {
      if (horizontal === false || event.touches.length !== 1) return;
      const dx = event.touches[0].clientX - startX;
      const dy = event.touches[0].clientY - startY;

      if (horizontal === null) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        horizontal = Math.abs(dx) > Math.abs(dy);
      }

      if (horizontal) {
        deltaX = dx;
        event.preventDefault();
      }
    }, { passive: false });

    slider.addEventListener('touchend', () => {
      if (horizontal && Math.abs(deltaX) > SWIPE_THRESHOLD) {
        go(deltaX < 0 ? index + 1 : index - 1);
      }
      horizontal = null;
      deltaX = 0;
    });
  });

  sorayaRoot.querySelectorAll('[data-soraya-video-card]').forEach((card) => {
    const video = card.querySelector('[data-soraya-video]');
    const toggle = card.querySelector('[data-soraya-video-toggle]');
    if (!video || !toggle) return;

    const setPlaying = (playing) => {
      toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      card.toggleAttribute('data-playing', playing);
    };

    const togglePlayback = () => {
      if (video.paused) {
        video.muted = false;
        video.play();
      } else {
        video.pause();
      }
    };

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      togglePlayback();
    });

    video.addEventListener('click', togglePlayback);

    video.addEventListener('play', () => setPlaying(true));
    video.addEventListener('pause', () => setPlaying(false));
    video.addEventListener('ended', () => setPlaying(false));
  });

  const qtyPicker = sorayaRoot.querySelector('[data-qty-picker]');
  if (qtyPicker) {
    const options = Array.from(qtyPicker.querySelectorAll('.qty-opt'));
    const cartLink = sorayaRoot.querySelector('[data-cart-link]');
    const cartLabel = sorayaRoot.querySelector('.cart');
    const totalEl = sorayaRoot.querySelector('[data-qty-total]');
    const compareEl = sorayaRoot.querySelector('[data-qty-compare]');
    const badgeEl = sorayaRoot.querySelector('[data-qty-badge]');
    const saveEl = sorayaRoot.querySelector('[data-qty-save]');
    const giftSets = Array.from(sorayaRoot.querySelectorAll('[data-gifts]'));
    const heroImg = sorayaRoot.querySelector('[data-bundle-img]');

    const select = (option) => {
      options.forEach((o) => {
        const on = o === option;
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      const total = option.dataset.totalStr;

      // never blank the price area if a tier is missing its formatted price
      if (totalEl && total) totalEl.textContent = total;

      // struck-through price and discount badge only appear when there is a real saving
      if (compareEl) {
        const compare = option.dataset.compareStr;
        compareEl.textContent = compare || '';
        compareEl.hidden = !compare;
      }

      // 'SAVE $30' next to the crossed-out price, only when this bundle has a saving
      if (saveEl) {
        const save = option.dataset.saveStr;
        saveEl.textContent = save || '';
        saveEl.hidden = !save || !option.dataset.compareStr;
      }

      if (badgeEl) {
        const badge = option.dataset.badgeStr;
        badgeEl.textContent = badge || '';
        badgeEl.hidden = !badge;
      }

      // first slider image shows this bundle and the gifts it comes with
      if (heroImg && option.dataset.heroImg) heroImg.src = option.dataset.heroImg;

      // free gifts stack: show only the set that belongs to this bundle size
      giftSets.forEach((set) => {
        set.hidden = set.dataset.gifts !== option.dataset.qty;
        if (!set.hidden && set.dataset.worth) {
          const worthEl = sorayaRoot.querySelector('[data-gifts-worth]');
          if (worthEl) worthEl.textContent = set.dataset.worth;
        }
      });

      // put the price on the button
      if (cartLabel && total) cartLabel.textContent = 'ADD TO CART — ' + total;

      if (cartLink) {
        const root = cartLink.dataset.cartRoot || '/cart/';
        const tierVariant = option.dataset.variant;
        // a real per-tier variant is one line item; otherwise fall back to qty of the base variant
        cartLink.href = tierVariant
          ? root + tierVariant + ':1'
          : root + cartLink.dataset.cartFallbackVariant + ':' + option.dataset.qty;
      }
    };

    options.forEach((option) => option.addEventListener('click', () => select(option)));

    const initial = options.find((o) => o.classList.contains('is-selected')) || options[0];
    if (initial) select(initial);
  }
}

/* Customer reviews: rating summary, search + rating filter, read more, pagination.
   Average and bars are computed from each review's data-rating, so they stay correct when ratings change. */
(() => {
  const list = document.querySelector('[data-rev-grid]');
  const pager = document.querySelector('[data-rev-pager]');
  if (!list || !pager) return;

  const items = Array.from(list.querySelectorAll('[data-rev-item]'));
  const PER_PAGE = 5;
  const pagesWrap = pager.querySelector('[data-rev-pages]');
  const prev = pager.querySelector('[data-rev-prev]');
  const next = pager.querySelector('[data-rev-next]');
  const search = document.querySelector('[data-rv-search]');
  const ratingSel = document.querySelector('[data-rv-rating]');
  const empty = document.querySelector('[data-rv-empty]');

  // summary
  const ratings = items.map((el) => Number(el.dataset.rating) || 0);
  if (ratings.length) {
    const avg = ratings.reduce((a, b) => a + b, 0) / ratings.length;
    const avgEl = document.querySelector('[data-rv-avg]');
    const totalEl = document.querySelector('[data-rv-total]');
    if (avgEl) avgEl.textContent = avg.toFixed(2).replace(/0$/, '');
    if (totalEl) totalEl.textContent = ratings.length + (ratings.length === 1 ? ' review' : ' reviews');
    document.querySelectorAll('[data-rv-bar]').forEach((bar) => {
      const n = Number(bar.dataset.rvBar);
      const count = ratings.filter((r) => r === n).length;
      bar.style.width = (count / ratings.length) * 100 + '%';
    });
  }

  // read more: clamp long reviews, reveal on click
  items.forEach((el) => {
    const text = el.querySelector('[data-rv-text]');
    const more = el.querySelector('[data-rv-more]');
    if (!text || !more) return;
    const long = text.textContent.trim().length > 260 || text.querySelectorAll('p').length > 1;
    if (!long) return;
    text.classList.add('is-clamped');
    more.hidden = false;
    more.addEventListener('click', () => {
      const open = text.classList.toggle('is-clamped') === false;
      more.textContent = open ? 'Show less' : 'Read more';
    });
  });

  let page = 0;
  let matches = items;

  function renderPager(pageCount) {
    pagesWrap.textContent = '';
    for (let i = 0; i < pageCount; i++) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'rev-page' + (i === page ? ' active' : '');
      b.setAttribute('aria-label', 'Reviews page ' + (i + 1));
      b.addEventListener('click', () => show(i));
      pagesWrap.appendChild(b);
    }
  }

  function show(i) {
    const pageCount = Math.max(1, Math.ceil(matches.length / PER_PAGE));
    page = Math.max(0, Math.min(pageCount - 1, i));
    items.forEach((el) => { el.hidden = true; });
    matches.slice(page * PER_PAGE, (page + 1) * PER_PAGE).forEach((el) => { el.hidden = false; });
    pager.hidden = pageCount < 2;
    if (empty) empty.hidden = matches.length > 0;
    prev.disabled = page === 0;
    next.disabled = page === pageCount - 1;
    renderPager(pageCount);
  }

  function applyFilters() {
    const q = (search?.value || '').trim().toLowerCase();
    const r = ratingSel?.value || '';
    matches = items.filter((el) =>
      (!r || el.dataset.rating === r) &&
      (!q || el.textContent.toLowerCase().includes(q))
    );
    show(0);
  }

  search?.addEventListener('input', applyFilters);
  ratingSel?.addEventListener('change', applyFilters);
  prev.addEventListener('click', () => show(page - 1));
  next.addEventListener('click', () => show(page + 1));
  applyFilters();
})();
